import * as React from 'react'
import TitledContainer from '../components/TitledContainer'
import { useTranslations } from '../store/translations/hooks'
import { useLocation } from 'react-router'
import { TK } from '../store/translations/translationKeys'
import { Link } from 'react-router-dom'
import { paths } from '../app/constants'

export const ActionResult: React.FC = () => {
    const t = useTranslations()
    const location = useLocation()

    const message = React.useMemo(() => {
        switch(location.hash) {
            case '#emailConfirmed': return t(TK.emailConfirmed)
            case '#newPasswordSent': return t(TK.newPasswordSent)
            case '#emailNotConfirmed': return t(TK.emailNotConfirmed)
            case '#newPasswordNotGenerated': return t(TK.newPasswordNotGenerated)
            default: return t(TK.somethingWentWrong)
        }
    }, [location.hash])

    return (
        <TitledContainer title={message}>
            <Link to={paths.root}>{t(TK.goBack)}</Link>
        </TitledContainer>
    )
}